import React from 'react';

import AdminImportPage from '../shared/adminImportPage.component';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';
import columnDefinitions from '../../shared/columnDefinitions/communicationsManagement';

import { sharedActions } from './store/actions';
import AddEditCommunicationsModal from './addEditCommunicationsModal.component';
import AdminColumnRenderer from './communicationsAdminColumnRenderer.component';
import DeleteCommunicationModal from './deleteCommunicationsModal.component';

const CommunicationsManagementPage = () => (
  <AdminImportPage
    pageName={adminPageNames.COMMUNICATIONS_MANAGEMENT}
    canModify
    pageTitle={adminPageTitles.COMMUNICATIONS_MANAGEMENT}
    AddEditEntityModal={AddEditCommunicationsModal}
    RemoveEntityModal={DeleteCommunicationModal}
    addEntityMessage="Add Communication"
    adminColumnRenderer={AdminColumnRenderer}
    actions={sharedActions}
    columnDefs={columnDefinitions}
    singularTitle
  />
);

export default CommunicationsManagementPage;
